'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _reactSlidedown = require('react-slidedown');

var _reactScroll = require('react-scroll');

var _components = require('../../components');

var _AmazonVanguardLanding = require('./AmazonVanguardLanding.css');

var _AmazonVanguardLanding2 = _interopRequireDefault(_AmazonVanguardLanding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmazonVanguardLanding = (_dec = (0, _reactCssModules2.default)(_AmazonVanguardLanding2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AmazonVanguardLanding, _Component);

  function AmazonVanguardLanding(props) {
    (0, _classCallCheck3.default)(this, AmazonVanguardLanding);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AmazonVanguardLanding.__proto__ || (0, _getPrototypeOf2.default)(AmazonVanguardLanding)).call(this, props));

    _this.state = {
      title: 'Save for your future without ruining theirs',
      description: 'Vanguard’s default 401(k) option for Amazon employees is investing hundreds of millions of dollars into agribusiness companies that are devastating our rainforests.',
      url: _config2.default.domain + _config2.default.routes.amazonVanguardLanding,
      mobileBannerFixed: true,
      showLetter: false,
      showFullPetition: false
    };
    return _this;
  }

  (0, _createClass3.default)(AmazonVanguardLanding, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          title = _state.title,
          description = _state.description,
          url = _state.url;


      var headlineImg = require('../../../static/images/monkeys-circle.jpg');

      var mobileBannerStyle = this.state.mobileBannerFixed ? 'mobile-fixed' : 'mobile-relative';

      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'hl-wrap' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { styleName: 'hl' },
                title
              ),
              _react2.default.createElement('img', {
                src: headlineImg,
                alt: 'Save for your future without ruining theirs',
                styleName: 'hl-img-sm visible-xs'
              }),
              _react2.default.createElement(
                'div',
                { styleName: 'copy' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Every year, the world loses an area of tropical rainforest the size of the United Kingdom.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber, and cattle is also responsible for almost one quarter of all global greenhouse gas emissions. Corporate control of land used for industrial plantation agriculture is also a leading cause of violent land conflicts, as these activities dispossess and displace local indigenous communities.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'What most Amazon employees don\u2019t know is that the Vanguard funds in their 401(k) have millions of dollars invested into agribusiness companies that are devastating our rainforests. Vanguard\u2019s continued financing of the world\u2019s worst deforestation companies exposes its investors, like those in the Amazon 401(k), to reputational and financial risk.'
                ),
                _react2.default.createElement(
                  'p',
                  { styleName: 'scroll-link' },
                  _react2.default.createElement(
                    _reactScroll.Link,
                    {
                      activeClass: 'active-scroll-link',
                      to: 'section1',
                      spy: true,
                      smooth: true,
                      offset: -70,
                      duration: 500
                    },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Urge Vanguard to offer sustainable target date funds that can be the default 401(k) option for Amazon employees.'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'hidden-xs' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'Most Amazon employees have no idea Vanguard is using their retirement savings to funnel money into agribusiness companies like JBS and Bunge, which source from farms that have been fined for illegal deforestation and slave labor practices in the Brazilian Amazon.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Large fund managers like Vanguard can move the entire market and play a crucial role in averting catastrophe, and could instead finance the transition to a livable planet. But, unfortunately, they won\u2019t do it without pressure from us.'
                  ),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'scroll-link' },
                    _react2.default.createElement(
                      _reactScroll.Link,
                      {
                        activeClass: 'active-scroll-link',
                        to: 'section1',
                        spy: true,
                        smooth: true,
                        offset: -70,
                        duration: 500
                      },
                      _react2.default.createElement(
                        'b',
                        null,
                        'Urge Vanguard to offer sustainable target date funds to Amazon employees!'
                      )
                    )
                  ),
                  _react2.default.createElement(_components.VanguardCompanyLetter, null)
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'after-petition-links hidden-xs' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'after-petition-links-lbl' },
                    'More'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'after-petition-links-div' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.plans + '/amazon-com',
                        title: 'Amazon 401(k) scorecard',
                        xstrong: true
                      },
                      'See the scorecard for the Amazon 401(k)',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'after-petition-links-div' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.eduCenter,
                        title: 'Action center',
                        xstrong: true
                      },
                      'Action center',
                      _react2.default.createElement(_components.LinkIcon, null)
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'hl-img-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'petition-widget-wrap' },
                _react2.default.createElement('img', {
                  src: headlineImg,
                  alt: 'Save for your future without ruining theirs',
                  styleName: 'hl-img hidden-xs'
                }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'sticky-widget ' + mobileBannerStyle },
                  _react2.default.createElement('div', { id: 'section1' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'sticky-widget-close visible-xs' },
                    _react2.default.createElement(
                      'div',
                      {
                        onClick: function onClick() {
                          //
                          _this2.setState({
                            mobileBannerFixed: false
                          });
                        }
                      },
                      _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-close' })
                    )
                  ),
                  _react2.default.createElement(
                    'h2',
                    { styleName: 'thumbs-up-top-label' },
                    'Vanguard: Offer Amazon Employees Sustainable Target Date Funds!'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'c' },
                    _react2.default.createElement(
                      'h3',
                      { styleName: 'thumbs-up-top-label-2' },
                      'Sign this petition'
                    )
                  ),
                  _react2.default.createElement(_components.PetitionForm, {
                    petitionConfig: _config2.default.petitionConfigs.amazonVanguard
                  })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'visible-xs' },
            _react2.default.createElement(
              'div',
              {
                styleName: 'show-more-button',
                title: 'Learn more',
                onClick: function onClick(e) {
                  _this2.setState({ showFullPetition: !_this2.state.showFullPetition });
                }
              },
              'Learn more',
              _react2.default.createElement(_components.LinkIcon, { faclass: this.state.showFullPetition ? 'fa-angle-double-up' : 'fa-angle-double-down' })
            ),
            _react2.default.createElement(
              _reactSlidedown.SlideDown,
              null,
              this.state.showFullPetition ? _react2.default.createElement(
                'div',
                { styleName: 'copy' },
                _react2.default.createElement(
                  'p',
                  null,
                  'Most Amazon employees have no idea Vanguard is using their retirement savings to funnel money into agribusiness companies like JBS and Bunge, which source from farms that have been fined for illegal deforestation and slave labor practices in the Brazilian Amazon.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Large fund managers like Vanguard can move the entire market and play a crucial role in averting catastrophe, and could instead finance the transition to a livable planet. But, unfortunately, they won\u2019t do it without pressure from us.'
                ),
                _react2.default.createElement(
                  'p',
                  { styleName: 'scroll-link' },
                  _react2.default.createElement(
                    _reactScroll.Link,
                    {
                      activeClass: 'active-scroll-link',
                      to: 'section1',
                      spy: true,
                      smooth: true,
                      offset: -70,
                      duration: 500
                    },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Urge Vanguard to offer sustainable target date funds to Amazon employees!'
                    )
                  )
                ),
                _react2.default.createElement(_components.VanguardCompanyLetter, null)
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'after-petition-links visible-xs' },
            _react2.default.createElement(
              'div',
              { styleName: 'after-petition-links-lbl' },
              'More'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'after-petition-links-div' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.plans + '/amazon-com',
                  title: 'Amazon 401(k) scorecard',
                  xstrong: true
                },
                'See the scorecard for the Amazon 401(k)',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'after-petition-links-div' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.eduCenter,
                  title: 'Action center',
                  xstrong: true
                },
                'Action center',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          )
        )
      );
    }
  }]);
  return AmazonVanguardLanding;
}(_react.Component)) || _class);
exports.default = AmazonVanguardLanding;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AmazonVanguardLanding/AmazonVanguardLanding.js
// module id = 1459
// module chunks = 0